module.exports = __webpack_public_path__ + "img/img_xiaozhishi@2x.f0419a1e.png";